import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import StudyFootnotes from '../../components/common/StudyFootnotes/StudyFootnotes';
import { MRI_STUDY_WARNING_TYPE_6, MRI_STUDY_WARNING_TYPE_7,
  MRI_STUDY_WARNING_TYPE_8 } from '../../constants';
import { CELL_COUNT_31_60, CELL_COUNT_BELOW_31, MRI_CELL_COUNT_BELOW_50,
  MRI_CELL_COUNT_BELOW_25, MRI_CELL_COUNT_25_49, MRI_CELL_COUNT_BELOW_31,
  MRI_CELL_COUNT_31_59 } from '../../messages/ReportsMessages';

const SalesCatalystSectionBottom = props => {
  const isMRISpecificStudy = props.salesCatalystStudyInfo &&
    props.salesCatalystStudyInfo.ss ?
    props.salesCatalystStudyInfo.ss.includes('MRI') : false;
  const warningType = props.salesCatalystStudyInfo.wnt;
  let messageComponent = (<div className="small-6 columns text-align-left">
    {CELL_COUNT_31_60}<br />
    {CELL_COUNT_BELOW_31}
  </div>);

  if (isMRISpecificStudy) {
    if (warningType === MRI_STUDY_WARNING_TYPE_6) {
      messageComponent = (<div className="small-6 columns text-align-left">
        {MRI_CELL_COUNT_BELOW_50}
      </div>);
    } else if (warningType === MRI_STUDY_WARNING_TYPE_7) {
      messageComponent = (<div className="small-6 columns text-align-left">
        {MRI_CELL_COUNT_25_49}<br />
        {MRI_CELL_COUNT_BELOW_25}
      </div>);
    } else if (warningType === MRI_STUDY_WARNING_TYPE_8) {
      messageComponent = (<div className="small-6 columns text-align-left">
        {MRI_CELL_COUNT_31_59}<br />
        {MRI_CELL_COUNT_BELOW_31}
      </div>);
    }
  }
  return (
    <div className="row expanded font-11 padding-astrick-pdf">
      {props.asteriskInfo && messageComponent}
      <StudyFootnotes
        studyList={props.studyList}
        selectedStudy={props.salesCatalystStudyInfo}
        className={`${props.asteriskInfo ? 'small-6' : 'small-12'} columns text-align-right`}
      />
    </div>
  );
};

SalesCatalystSectionBottom.propTypes = {
  salesCatalystStudyInfo: PropTypes.shape({
    ss: PropTypes.string,
    wnt: PropTypes.number,
    // studyDescription: PropTypes.string,
  }),
  asteriskInfo: PropTypes.bool,
  studyList: PropTypes.arrayOf(PropTypes.object),
};

function mapStateToProps(state) {
  return {
    salesCatalystStudyInfo: typeof state.study.salesCatalystStudy !== 'undefined' ?
    state.study.salesCatalystStudy : [],
    studyList: state.study.salesCatalystStudies,
  };
}

export default connect(
  mapStateToProps,
  null,
)(SalesCatalystSectionBottom);
